import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import NoContentView from "app/pages/sales-intelligence/pages/home/components/common/NoContentView/NoContentView";
import { StyledList, StyledListItem, StyledSubTitle } from "app/pages/sales-intelligence/pages/home/components/styles";
import type { Translatable } from "app/pages/sales-intelligence/types";
import type { ReactNode } from "react";

const listItems: Translatable[] = [
    { key: "si.pages.home.card.saved-searches.no-content.item-1.text" },
    { key: "si.pages.home.card.saved-searches.no-content.item-2.text" },
    { key: "si.pages.home.card.saved-searches.no-content.item-3.text" },
];

type Props = {
    actions: NonNullable<ReactNode>;
};

const EmptySavedSearchesView = ({ actions }: Props) => {
    return (
        <NoContentView actions={actions}>
            <I18n
                translatable={{ key: "si.pages.home.card.saved-searches.no-content.title" }}
                element={StyledSubTitle}
            />

            <StyledList>
                {listItems.map((item, index) => (
                    <I18n
                        key={index}
                        translatable={item}
                        element={StyledListItem}
                    />
                ))}
            </StyledList>
        </NoContentView>
    );
};

export default EmptySavedSearchesView;
